import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
import _typeof from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
// client js begin
import Onview from '@tencent/vft-onview';
import { imageLoader } from "./util/loaders";
import bus from '@/util/bus';
// client js end

var isInNode = typeof window === 'undefined' && (typeof global === "undefined" ? "undefined" : _typeof(global)) === 'object';
var blankSvg = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjwvc3ZnPg==';
export default {
  name: 'VImage',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false,
      default: ''
    },
    placeholderType: {
      type: String,
      default: 'image' // 值可为 preview|color|image
    },

    placeholderColor: {
      type: String,
      required: false,
      default: 'rgba(0,0,0,.05)'
    },
    placeholderImage: {
      type: String,
      required: false,
      default: '//puui.qpic.cn/vupload/0/20181103_1541227036811_35m1cnuthg6.png/0'
    },
    offsetTop: {
      type: Number,
      required: false,
      default: -400
    },
    lazyLoad: {
      type: Boolean,
      default: false
    },
    simpleMode: {
      type: Boolean,
      default: true
    },
    errMsg: {
      type: String,
      default: '图片加载失败，点击重试'
    }
  },
  data: function data() {
    return {
      isRealImageShow: !this.lazyLoad && this.simpleMode,
      error: false,
      retryCount: 0,
      isLoad: false,
      previewImage: blankSvg // 默认为一个空白的svg图
    };
  },
  created: function created() {
    // 同构特殊逻辑
    if (this.placeholderType === 'preview' && isInNode) {
      this.isRealImageShow = false;
      var previewImage = global.getLQIP(this._src);
      if (previewImage) {
        this.previewImage = previewImage;
      }
    }
  },
  beforeMount: function beforeMount() {
    // 同构特殊逻辑，防止客户端融合过程中出现不一致
    if (this.placeholderType === 'preview' && this.$el) {
      this.isRealImageShow = false;
      this.previewImage = this.$el.querySelector('img').style.backgroundImage.replace(/^url\("?/, '').replace(/"\)$/, '');
    }
  },
  computed: {
    _src: function _src() {
      return this.src.replace(/^https?:/, '') + (this.retryCount ? "?retryCount=".concat(this.retryCount) : '');
    },
    imgSrc: function imgSrc() {
      return this.isRealImageShow ? this._src : blankSvg;
    },
    imgStyle: function imgStyle() {
      if (this.placeholderType === 'color') {
        return this.isLoad && this.placeholderColor ? {} : {
          backgroundColor: this.placeholderColor
        };
      } else {
        return {
          backgroundImage: "url(".concat(this.placeholderType === 'image' ? this.placeholderImage : this.previewImage, ")")
        };
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.setup();
    this.$watch('lazyLoad', this.setup);
    this.$watch('offsetTop', this.setup);
    this.$watch('simpleMode', this.setup);

    // 监听下拉刷新事件，重试失败图片
    var retryErrorImage = function retryErrorImage() {
      if (_this.error) {
        _this.retryLoadImg();
      }
    };
    bus.$on('pull2Refresh', retryErrorImage);
    this.$on('hook:beforeDestroy', function () {
      bus.$off('pull2Refresh', retryErrorImage);
    });
  },
  updated: function updated() {
    this.setup();
  },
  beforeDestroy: function beforeDestroy() {
    this.onviewUnbind && this.onviewUnbind();
    this.loader && this.loader.cancel();
    this.loader = this.onviewUnbind = undefined;
  },
  methods: {
    setup: function setup() {
      this.onviewUnbind && this.onviewUnbind();
      if (this.isRealImageShow) return;
      if (this.lazyLoad) {
        this.onviewUnbind = Onview(this.$el, {
          once: true,
          offsetTop: this.offsetTop
        }, this.loadImg);
      } else {
        this.loadImg();
      }
    },
    loadImg: function () {
      var _loadImg = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.simpleMode) {
                  _context.next = 4;
                  break;
                }
                this.isRealImageShow = true;
                _context.next = 14;
                break;
              case 4:
                _context.prev = 4;
                this.loader = imageLoader(this._src);
                _context.next = 8;
                return this.loader;
              case 8:
                this.isRealImageShow = true;
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                this.error = _context.t0;
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 11]]);
      }));
      function loadImg() {
        return _loadImg.apply(this, arguments);
      }
      return loadImg;
    }(),
    retryLoadImg: function retryLoadImg() {
      this.retryCount++;
      this.error = false;
      this.loadImg();
    }
  }
};